var exports = {
  "nd": "VoiceChannelChatPanel.module__panel___dzIxY2",
  "wx": "VoiceChannelChatPanel.module__header___dzIxY2",
  "nr": "VoiceChannelChatPanel.module__headerIcon___dzIxY2",
  "qd": "VoiceChannelChatPanel.module__headerTitle___dzIxY2",
  "Qs": "VoiceChannelChatPanel.module__content___dzIxY2",
};

module.exports = exports;
